import { render, staticRenderFns } from "./ServicePrices.vue?vue&type=template&id=70788296"
import script from "./ServicePrices.vue?vue&type=script&lang=js"
export * from "./ServicePrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports